import { keyValueList } from "../../../fable_modules/fable-library-js.4.19.0/MapUtil.js";
import { filter, forAll, map, empty, singleton, append } from "../../../fable_modules/fable-library-js.4.19.0/List.js";
import { Types_RequestProperties } from "../../../fable_modules/Fable.Fetch.2.7.0/Fetch.fs.js";
import { Auto_generateBoxedDecoderCached_Z6670B51 } from "../../../fable_modules/Thoth.Json.10.4.1/./Decode.fs.js";
import { Dashboard_Lists_DokumentenDepot, Dashboard_Lists_DokumentenDepot_$reflection } from "../../../../Bfs.Web.Data.Service.Contracts/Kundenportal.Contracts.fs.js";
import { class_type, list_type } from "../../../fable_modules/fable-library-js.4.19.0/Reflection.js";
import { CaseStrategy } from "../../../fable_modules/Thoth.Json.10.4.1/Types.fs.js";
import { sendJson, errorString, Encoders } from "../../../../Bfs.Web.Portale/./Http.fs.js";
import { fromString } from "../../../../Bfs.Web.Portale/../Bfs.Web.Kundenportal/fable_modules/Thoth.Json.10.4.1/Decode.fs.js";
import { stringHash, uncurry2 } from "../../../fable_modules/fable-library-js.4.19.0/Util.js";
import { Auto_generateBoxedEncoder_437914C6, toString } from "../../../fable_modules/Thoth.Json.10.4.1/./Encode.fs.js";
import { Msg, Model } from "./Types.fs.js";
import { GlobalMsg, GlobalMessageBox_Error_Z721C83C5 } from "../../../../Bfs.Web.Portale/Types.fs.js";
import { Cmd_none } from "../../../fable_modules/Fable.Elmish.4.2.0/cmd.fs.js";
import { request } from "../../../../Bfs.Web.Portale/Http.fs.js";
import { List_distinct } from "../../../fable_modules/fable-library-js.4.19.0/Seq2.js";

export function Http_getData(_arg) {
    const response = fetch("/api/dashboard/dokumenten-depot-list", keyValueList(append(singleton(new Types_RequestProperties(4, ["include"])), empty()), 1));
    const decoder = Auto_generateBoxedDecoderCached_Z6670B51(list_type(Dashboard_Lists_DokumentenDepot_$reflection()), new CaseStrategy(1, []), Encoders());
    return response.then((response_1_1) => {
        if (!(response_1_1.ok)) {
            throw new Error(errorString(response_1_1));
        }
        else {
            const pr = response_1_1.text();
            return pr.then((res) => {
                const matchValue = fromString(uncurry2(decoder), res);
                if (matchValue.tag === 1) {
                    throw new Error(matchValue.fields[0]);
                }
                else {
                    return matchValue.fields[0];
                }
            });
        }
    });
}

export function Http_postAuslagern(lagerplatzReportIds) {
    return sendJson("/api/dashboard/dokumenten-depot-list-auslagern", toString(0, Auto_generateBoxedEncoder_437914C6(list_type(class_type("System.Guid")), undefined, undefined, undefined)(lagerplatzReportIds)), singleton(new Types_RequestProperties(4, ["include"])), "POST");
}

export function State_init(_arg, _arg_1, _arg_2) {
    return [new Model(true, empty(), false, false, undefined), singleton((dispatch) => {
        dispatch(new Msg(0, []));
    })];
}

export function State_update(msg, model) {
    let msg_2, msg_3;
    switch (msg.tag) {
        case 1:
            if (msg.fields[0].tag === 1) {
                return [new Model(false, empty(), false, false, undefined), (msg_2 = (new Msg(2, [new GlobalMsg(3, [GlobalMessageBox_Error_Z721C83C5("Die Daten können zur Zeit leider nicht geladen werden.")])])), singleton((dispatch_1) => {
                    dispatch_1(msg_2);
                }))];
            }
            else {
                return [new Model(false, msg.fields[0].fields[0], false, model.ShowAuslagernSuccessDialog, model.DokumenteZumAuslagern), Cmd_none()];
            }
        case 3: {
            const model_1 = new Model(model.Loading, map((x) => {
                if (x.LagerplatzReportId === msg.fields[0]) {
                    return new Dashboard_Lists_DokumentenDepot(x.LagerplatzReportId, x.SendungNr, x.RechnungsNrExtern, x.KlientPatient, x.DokumentArt, x.Grund, x.EingelagertAm, x.RuecksendungAm, !x.IsChecked, x.AuslagerungAngefordert, x.ZeitAuslagerung);
                }
                else {
                    return x;
                }
            }, model.Data), model.AllChecked, model.ShowAuslagernSuccessDialog, model.DokumenteZumAuslagern);
            return [new Model(model_1.Loading, model_1.Data, forAll((x_2) => x_2.IsChecked, filter((x_1) => (x_1.AuslagerungAngefordert == null), model_1.Data)), model_1.ShowAuslagernSuccessDialog, model_1.DokumenteZumAuslagern), Cmd_none()];
        }
        case 4: {
            const isChecked = !model.AllChecked;
            return [new Model(model.Loading, map((x_3) => {
                if (x_3.AuslagerungAngefordert == null) {
                    return new Dashboard_Lists_DokumentenDepot(x_3.LagerplatzReportId, x_3.SendungNr, x_3.RechnungsNrExtern, x_3.KlientPatient, x_3.DokumentArt, x_3.Grund, x_3.EingelagertAm, x_3.RuecksendungAm, isChecked, x_3.AuslagerungAngefordert, x_3.ZeitAuslagerung);
                }
                else {
                    return x_3;
                }
            }, model.Data), isChecked, model.ShowAuslagernSuccessDialog, model.DokumenteZumAuslagern), Cmd_none()];
        }
        case 5:
            return [new Model(model.Loading, model.Data, model.AllChecked, model.ShowAuslagernSuccessDialog, msg.fields[0]), Cmd_none()];
        case 6:
            return [model, request(Http_postAuslagern, List_distinct(msg.fields[0], {
                Equals: (x_4, y) => (x_4 === y),
                GetHashCode: stringHash,
            }), (Item_1) => (new Msg(7, [Item_1])))];
        case 7:
            if (msg.fields[0].tag === 1) {
                return [model, (msg_3 = (new Msg(2, [new GlobalMsg(3, [GlobalMessageBox_Error_Z721C83C5("Beim Auslagern ist ein Fehler aufgetreten.")])])), singleton((dispatch_2) => {
                    dispatch_2(msg_3);
                }))];
            }
            else {
                return [new Model(model.Loading, model.Data, model.AllChecked, true, model.DokumenteZumAuslagern), singleton((dispatch) => {
                    dispatch(new Msg(0, []));
                })];
            }
        case 8:
            return [new Model(model.Loading, model.Data, model.AllChecked, false, undefined), Cmd_none()];
        case 2:
            return [model, Cmd_none()];
        default:
            return [new Model(true, empty(), model.AllChecked, model.ShowAuslagernSuccessDialog, model.DokumenteZumAuslagern), request(() => Http_getData(undefined), undefined, (Item) => (new Msg(1, [Item])))];
    }
}

//# sourceMappingURL=State.fs.js.map
